import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { toast } from "react-toastify";

import ImageEditor from "tui-image-editor";
import "tui-image-editor/dist/tui-image-editor.css";
import ImageEditorTheme from "../ImageEditor/theme/WhiteTheme";

import { TTP_API_URL } from "Config";
import { saveMedia } from "Thunks";
import { getUserAllowedLanguages, purifyString } from "Utils";
import { resetMediaEditor, setMediaEditor } from "Actions";
import TagsInput from "Common/TagsInput";
import UsersSelect from "Common/UsersSelect";
import UsersMultiSelect from "Common/UsersMultiSelect";
import Button from "Common/Button/Button";
//import StatefulButton from "Common/Button/StatefulButton";
import Loader from "Common/Loader/Loader";
import Checkmark from "Common/Checkmark/Checkmark";
import ArrowLeftIcon from "Common/ArrowLeftIcon";
import ArrowRightIcon from "Common/ArrowRightIcon";
import Switch from "Common/Switch/Switch/Switch";
import MultiSwitchContainer from "Common/Switch/MultiSwitch/MultiSwitchContainer";
import Tabs from "Tabs/TabsComponent";
import FormInput from "Common/FormInput";

import _ from "i18n";

const customStyles = {
  content: {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    backgroundColor: "#fff",
    border: "none",
    overflow: "none",
    padding: 0,
    top: "5%",
    left: "5%",
    right: "5%",
    bottom: "5%",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(41, 57, 77, 0.04)"
  }
};

Modal.setAppElement("#app");
Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.75)";

export class MediaEditor extends Component {
  widthInput = React.createRef();
  heightInput = React.createRef();
  titleInput = React.createRef();
  descriptionInput = React.createRef();
  altInput = React.createRef();
  copyrightInput = React.createRef();

  static propTypes = {
    loggedAs: PropTypes.string,
    isOpen: PropTypes.bool
  };

  state = {
    savingState: "default",
    savingError: null,
    currentTab: null,
    titleCurrentTab: null,
    descriptionCurrentTab: null,
    altCurrentTab: null,
    copyrightCurrentTab: null
  };

  componentDidMount() {
    const { setMediaEditor } = this.props;
    const languages = this.getUserLanguages();
    setMediaEditor({ languages });
    this.setState({
      curruentTab: languages[0],
      titleCurrentTab: languages[0],
      descriptionCurrentTab: languages[0],
      altCurrentTab: languages[0],
      copyrightCurrentTab: languages[0]
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { languages } = this.props;
    if (prevProps.languages !== languages) {
      this.setState({
        cuttentTab: languages[0],
        titleCurrentTab: languages[0],
        descriptionCurrentTab: languages[0],
        altCurrentTab: languages[0],
        copyrightCurrentTab: languages[0]
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      savingState: "default",
      savingError: null,
      currentTab: null,
      titleCurrentTab: null,
      descriptionCurrentTab: null,
      altCurrentTab: null,
      copyrightCurrentTab: null
    });
  }

  afterOpenModal = () => {
    const { media, lng } = this.props;

    const $editor = $("#image-editor");
    this.editor = new ImageEditor($editor, {
      includeUI: {
        loadImage: {
          path: media.fullMediaUrl
            ? `${media.fullMediaUrl}?v=${Math.random()}`
            : `${TTP_API_URL}/${media.webPath}?v=${Math.random()}`,
          name:
            media[`title${lng.charAt(0).toUpperCase() + lng.slice(1)}`] ||
            "image"
        },
        theme: ImageEditorTheme,
        menuBarPosition: "right"
      },
      cssMaxWidth: 600
    });

    // Fix bug : ImageEditor blocks Backspace keydow event
    this.editor._detachDomEvents && this.editor._detachDomEvents();

    window.editor = this.editor;

    // Remove header (containers tui logo ...)
    $editor.find(".tui-image-editor-header").remove();

    $(".tui-image-editor-menu-mask .tui-image-editor-button label").text(
      "Load Image"
    );
    $(".tui-image-editor-menu-mask .tui-image-editor-button.apply label").text(
      "Apply"
    );

    const btnMask = document.getElementById("tie-btn-mask");
    btnMask.title = "image";

    document
      .getElementById("tie-mask-apply")
      .getElementsByClassName("apply")
      .item(0)
      .addEventListener("click", e => {
        e.preventDefault();
        btnMask.click();
        return false;
      });
  };

  closeModal = () => {
    const { resetMediaEditor } = this.props;

    this.setState({ savingState: "default", savingError: null });

    setTimeout(e => {
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
      resetMediaEditor();
    });
  };

  handleSave = () => {
    const {
      media,
      titleFR,
      titleEN,
      titleNL,
      descriptionFR,
      descriptionEN,
      descriptionNL,
      altFR,
      altEN,
      altNL,
      copyrightFR,
      copyrightEN,
      copyrightNL,
      tags,
      creator,
      taggedUsers,
      mediaStatus,
      csScope,
      isPrivate,
      inTheNews,
      languages
    } = this.props;

    if (languages.length === 0) {
      toast.error(_("Please select a language"), { autoClose: false });
      return;
    }

    this.setState({ savingState: "saving" });

    // Resize
    const {
      clientWidth,
      clientHeight
      // width,
      // height
    } = this.editor._graphics._canvas.lowerCanvasEl;
    // console.log("ClientWidth : ", clientWidth);
    // console.log("clientHeight : ", clientHeight);

    // this.editor._graphics._canvas.lowerCanvasEl.width = clientWidth;
    // this.editor._graphics._canvas.lowerCanvasEl.height = clientHeight;
    // const resizer = new window.fabric.Image.filters.Resize();
    // const data = resizer.hermiteFastResize(
    //   this.editor._graphics._canvas.lowerCanvasEl,
    //   width,
    //   height,
    //   clientWidth,
    //   clientHeight
    // );

    // console.log("IMG data ", data);

    // Save
    this.editor._graphics._canvas.lowerCanvasEl.toBlob(blob => {
      this.props
        .saveMedia({
          id: media.id,
          titleFR,
          titleEN,
          titleNL,
          descriptionFR,
          descriptionEN,
          descriptionNL,
          altFR,
          altEN,
          altNL,
          copyrightFR,
          copyrightEN,
          copyrightNL,
          tags,
          overrideMainImage: true,
          file: blob,
          creator,
          taggedUsers,
          isPrivate,
          inTheNews,
          mediaStatus,
          csScope,
          width: clientWidth,
          height: clientHeight,
          languages
        })
        .then(() => {
          this.setState({ savingState: "success" });
          setTimeout(() => {
            this.setState({ savingState: "default" });
            this.closeModal();
          }, 3000);
        })
        .catch(e => {
          this.setState({ savingState: "error", savingError: e });
          setTimeout(
            () => this.setState({ savingState: "default", savingError: null }),
            3000
          );
        });
    });
  };

  handleChange = event => {
    const { value, name } = event.target;

    this.props.setMediaEditor({
      [name]: value
    });
  };

  handleTagsChange = tags => {
    this.props.setMediaEditor({ tags });
  };

  handleTitleChange = e => {
    const { titleCurrentTab } = this.state;
    const helplng = titleCurrentTab ? titleCurrentTab.toUpperCase() : "";

    this.props.setMediaEditor({
      [`title${helplng}`]: e.currentTarget.value
    });
  };

  handleDescriptionChange = e => {
    const { descriptionCurrentTab } = this.state;
    const helplng = descriptionCurrentTab
      ? descriptionCurrentTab.toUpperCase()
      : "";

    this.props.setMediaEditor({
      [`description${helplng}`]: e.currentTarget.value
    });
  };

  handleAltChange = e => {
    const { altCurrentTab } = this.state;
    const helplng = altCurrentTab ? altCurrentTab.toUpperCase() : "";

    this.props.setMediaEditor({
      [`alt${helplng}`]: e.currentTarget.value
    });
  };

  handleCopyrightChange = e => {
    const { copyrightCurrentTab } = this.state;
    const helplng = copyrightCurrentTab
      ? copyrightCurrentTab.toUpperCase()
      : "";

    this.props.setMediaEditor({
      [`copyright${helplng}`]: e.currentTarget.value
    });
  };

  handleIsPrivateChange = () => {
    this.props.setMediaEditor({ isPrivate: !this.props.isPrivate });
  };

  handleStatusChange = mediaStatus => {
    this.props.setMediaEditor({ mediaStatus });
  };

  handleCsScopeChange = e => {
    this.props.setMediaEditor({ csScope: e.target.value });
  };

  handleChangeInTheNews = () => {
    const { inTheNews, setMediaEditor } = this.props;
    setMediaEditor({ inTheNews: !inTheNews });
  };

  handleCreatorChange = creator => {
    this.props.setMediaEditor({ creator });
  };

  handleTaggedUsersChange = taggedUsers => {
    this.props.setMediaEditor({ taggedUsers });
  };

  changeCurrentMedia = newMedia => {
    const {
      setMediaEditor,
      keepValues,
      titleFR,
      titleEN,
      titleNL,
      descriptionFR,
      descriptionEN,
      descriptionNL,
      altFR,
      altEN,
      altNL,
      copyrightFR,
      copyrightEN,
      copyrightNL,
      tags,
      creator,
      mediaStatus,
      csScope,
      isPrivate,
      taggedUsers,
      languages,
      lng
    } = this.props;

    this.editor &&
      this.editor.loadImageFromURL(
        newMedia.fullMediaUrl
          ? `${newMedia.fullMediaUrl}?v=${Math.random()}`
          : `${TTP_API_URL}/${newMedia.webPath}?v=${Math.random()}`,
        newMedia[`title${lng.charAt(0).toUpperCase() + lng.slice(1)}`] ||
          "Image"
      );

    setMediaEditor({
      media: newMedia,
      isOpen: true,
      titleFR: newMedia.titleFr || (keepValues && titleFR) || "",
      titleEN: newMedia.titleEn || (keepValues && titleEN) || "",
      titleNL: newMedia.titleNl || (keepValues && titleNL) || "",
      descriptionFR:
        newMedia.descriptionFr || (keepValues && descriptionFR) || "",
      descriptionEN:
        newMedia.descriptionEn || (keepValues && descriptionEN) || "",
      descriptionNL:
        newMedia.descriptionNl || (keepValues && descriptionNL) || "",
      altFR: newMedia.altFr || (keepValues && altFR) || "",
      altEN: newMedia.altEn || (keepValues && altEN) || "",
      altNL: newMedia.altNl || (keepValues && altNL) || "",
      copyrightFR: newMedia.copyrightFr || (keepValues && copyrightFR) || "",
      copyrightEN: newMedia.copyrightEn || (keepValues && copyrightEN) || "",
      copyrightNL: newMedia.copyrightNl || (keepValues && copyrightNL) || "",
      creator: newMedia.creator || (keepValues && creator) || null,
      mediaStatus:
        newMedia.mediaStatus || (keepValues && mediaStatus) || "DRAFT",
      csScope: newMedia.csScope || (keepValues && csScope) || "INTRA_SHARE",
      isPrivate:
        newMedia.isPrivate !== undefined
          ? newMedia.isPrivate
          : keepValues
            ? isPrivate
            : false,
      taggedUsers:
        newMedia.taggedUsers && newMedia.taggedUsers.length > 0
          ? newMedia.taggedUsers
          : (keepValues && taggedUsers) || [],
      languages: newMedia.languages
        ? newMedia.languages
            .toUpperCase()
            .split(",")
            .sort()
        : (keepValues && languages) || ["FR", "NL", "EN"].sort(),
      tags:
        newMedia.tags && newMedia.tags.length > 0
          ? newMedia.tags
          : (keepValues && tags) || []
    });
  };

  handleWidthChange = () => {
    const width = this.widthInput.current.value;

    if (!width || width < 0) {
      return;
    }

    this.editor && this.editor.resizeCanvasDimension({ width });
    // this.widthInput.current.value = this.editor._graphics._canvas.lowerCanvasEl.clientWidth;
    setTimeout(() => {
      this.heightInput.current.value = this.editor._graphics._canvas.lowerCanvasEl.clientHeight;
    });
  };

  handleHeightChange = () => {
    const height = this.heightInput.current.value;

    if (!height || height < 0) {
      return;
    }

    this.editor && this.editor.resizeCanvasDimension({ height });

    setTimeout(() => {
      this.widthInput.current.value = this.editor._graphics._canvas.lowerCanvasEl.clientWidth;
    });
    // this.heightInput.current.value = this.editor._graphics._canvas.lowerCanvasEl.clientHeight;
  };

  getUserLanguages() {
    const { navCommunity } = this.props;

    return getUserAllowedLanguages(navCommunity);
  }

  setAllowLanguageValue(val, lng) {
    const { languages, setMediaEditor } = this.props;
    const allowed = this.getUserLanguages();
    let newLanguages = null;

    if (lng === "ALL") {
      newLanguages = val ? allowed.sort() : [];
      // setMediaEditor({ languages: val ? ["FR", "NL", "EN"].sort() : [] });
      // return;
    } else {
      newLanguages = val
        ? [...languages, lng].sort()
        : languages.filter(l => l !== lng).sort();
    }

    if (newLanguages.length === 0) {
      toast.error(_("At least one language should be selected"));
      //return;
    }

    setMediaEditor({
      languages: newLanguages
    });
  }

  renderTabs() {
    const { languages } = this.props;
    if (languages && languages.length > 1) {
      return (
        <Fragment>
          <Tabs>
            {languages.map(lng => (
              <div label={lng} icon={`/img/flags/${lng}.jpg`}>
                {this.renderInput("title", lng)}
                {this.renderInput("description", lng)}
                {this.renderInput("alt", lng)}
                {this.renderInput("copyright", lng)}
              </div>
            ))}
          </Tabs>
        </Fragment>
      );
    } else if (languages && languages.length === 1) {
      return (
        <Fragment>
          <div label={languages[0]}>
            {this.renderInput("title", languages[0])}
            {this.renderInput("description", languages[0])}
            {this.renderInput("alt", languages[0])}
            {this.renderInput("copyright", languages[0])}
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  renderLanguages() {
    const { languages } = this.props;
    const userLanguages = this.getUserLanguages();

    if (userLanguages.length <= 1) {
      return null;
    }

    return (
      <Fragment>
        <label className="cell small-4">{_("Languages")}</label>
        {["ALL", ...userLanguages].map(lng => (
          <div key={lng} className="switch-w-input">
            <div className="switch-w-input__switch">
              <span className="sidebar_role" style={{ marginRight: "auto" }}>
                {_(lng)}
              </span>
              <Switch
                name="englishLng"
                keyAttr="english-language"
                isChecked={
                  lng === "ALL"
                    ? languages.length === userLanguages.length
                    : languages.includes(lng)
                }
                onChange={val => this.setAllowLanguageValue(val, lng)}
              />
            </div>
          </div>
        ))}
      </Fragment>
    );
  }

  renderInput(name, lng) {
    const type = name === "description" ? "textarea" : "text";
    return (
      <FormInput
        className="cell small-8"
        ref={this[name + "Input"]}
        type={type}
        name={name + lng}
        label={_(name)}
        value={purifyString(this.props[name + lng])}
        onChange={this.handleChange}
      />
    );
  }

  renderDescription(lng) {
    // const { languages } = this.props;
    // const { descriptionCurrentTab } = this.state;
    // const helplng = descriptionCurrentTab
    //   ? descriptionCurrentTab.toUpperCase()
    //   : "";

    return (
      <React.Fragment>
        {/* <div className="mini-tabs">
          {(languages && languages.length > 1 ? languages : []).map(l => (
            <span
              key={l}
              className={l.toUpperCase() === helplng ? "active" : ""}
              onClick={() => {
                this.setState({ descriptionCurrentTab: l });
                this.descriptionInput.current.focus();
              }}
            >
              {_(l)}
            </span>
          ))}
        </div> */}
        <input
          className="cell small-8"
          type="text"
          name={`description${lng}`}
          ref={this.descriptionInput}
          value={purifyString(this.props[`description${lng}`])}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }

  renderAlt(lng) {
    // const { languages } = this.props;
    // const { altCurrentTab } = this.state;
    // const helplng = altCurrentTab ? altCurrentTab.toUpperCase() : "";

    return (
      <React.Fragment>
        {/* <div className="mini-tabs">
          {(languages && languages.length > 1 ? languages : []).map(l => (
            <span
              key={l}
              className={l.toUpperCase() === helplng ? "active" : ""}
              onClick={() => {
                this.setState({ altCurrentTab: l });
                this.altInput.current.focus();
              }}
            >
              {_(l)}
            </span>
          ))}
        </div> */}
        <input
          className="cell small-8"
          type="text"
          name={`alt${lng}`}
          ref={this.altInput}
          value={purifyString(this.props[`alt${lng}`])}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }

  renderCopyright(lng) {
    // const { languages } = this.props;
    // const { copyrightCurrentTab } = this.state;
    // const helplng = copyrightCurrentTab
    //   ? copyrightCurrentTab.toUpperCase()
    //   : "";

    return (
      <React.Fragment>
        {/* <div className="mini-tabs">
          {(languages && languages.length > 1 ? languages : []).map(l => (
            <span
              key={l}
              className={l.toUpperCase() === helplng ? "active" : ""}
              onClick={() => {
                this.setState({ copyrightCurrentTab: l });
                this.copyrightInput.current.focus();
              }}
            >
              {_(l)}
            </span>
          ))}
        </div> */}
        <input
          className="cell small-8"
          type="text"
          name={`copyright${lng}`}
          ref={this.copyrightInput}
          value={purifyString(this.props[`copyright${lng}`])}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }

  render() {
    const { savingState } = this.state;
    const {
      navCommunity,
      isOpen,
      media,
      tags,
      // description,
      // alt,
      // copyright,
      withNav,
      creator,
      taggedUsers,
      isPrivate,
      inTheNews,
      mediaStatus
    } = this.props;

    const scopes = ["EXTRA_CROSS", "INTRA_CROSS", "EXTRA_SHARE", "INTRA_SHARE"];

    let mediaPreferences = null;
    let cs_scope = "INTRA_SHARE";
    if (navCommunity) {
      const { csGeneralScope } = navCommunity;

      if (navCommunity.mediaSettings && navCommunity.mediaSettings.preferences)
        mediaPreferences = navCommunity.mediaSettings.preferences;
      cs_scope = csGeneralScope;

      if (mediaPreferences && mediaPreferences.cs_app_scope) {
        cs_scope = mediaPreferences.cs_app_scope;
      }
    }
    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        closeTimeoutMS={500}
        style={customStyles}
        contentLabel="Modal"
      >
        <div id="media-editor">
          <div className="rmodal ">
            <div className="rmodal__close">
              <button className="close " onClick={this.closeModal} />
            </div>
            <div className="cell rmodal__body grid-x">
              <div className="cell small-9 rmodal__left">
                <div id="image-editor" />
              </div>
              <div className="cell small-3 rmodal__right">
                <div className="rmodal__right-data">
                  <ul className="rmodal__right-infos">
                    <li>
                      <strong>{_("File type")} : </strong>
                      {media && media.meta && media.meta.mimeType}
                    </li>
                    <li>
                      <strong>{_("Uploaded at")} : </strong>
                      {media && media.createdAt}
                    </li>
                    <li>
                      <strong>{_("File size")} : </strong>
                      {media && media.meta && media.meta.size}
                    </li>
                    <li>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong>{_("Dimensions")} : </strong>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="number"
                            size="4"
                            defaultValue={
                              media && media.meta && media.meta.width
                            }
                            style={{ margin: 0, width: "70px" }}
                            ref={this.widthInput}
                            onChange={this.handleWidthChange}
                          />
                          <span style={{ margin: "0 0.5rem" }}>x</span>
                          <input
                            type="number"
                            size="4"
                            defaultValue={
                              media && media.meta && media.meta.height
                            }
                            style={{ margin: 0, width: "70px" }}
                            ref={this.heightInput}
                            onChange={this.handleHeightChange}
                          />
                        </div>
                      </div>
                      {/* {media &&
                      media.meta &&
                      media.meta.width &&
                      media.meta.height &&
                      `${media.meta.width} x ${media.meta.height}`} */}
                    </li>
                  </ul>
                  <hr />
                  {this.renderLanguages()}
                  <hr />
                  {this.renderTabs()}
                  <hr />

                  <ul className="rmodal__right-form">
                    <li className="grid-y">
                      <label className="cell small-4">{_("Tags")}</label>
                      <div className="cell small-8">
                        <TagsInput
                          selectedTags={tags}
                          onChange={this.handleTagsChange}
                        />
                      </div>
                    </li>
                    <li className="grid-y" style={{ paddingBottom: "1rem" }}>
                      <label className="cell small-4">{_("Status")}</label>
                      <MultiSwitchContainer
                        title=""
                        labels={[
                          _("Draft"),
                          _("Ready"),
                          _("Published"),
                          _("Masked"),
                          _("Archived")
                        ]}
                        selectedValue={mediaStatus}
                        vals={[
                          "DRAFT",
                          "READY",
                          "PUBLISHED",
                          "MASKED",
                          "ARCHIVED"
                        ]}
                        name="status"
                        afterChange={this.handleStatusChange}
                      />
                    </li>
                    <li className="grid-y">
                      <label className="cell small-4">{_("User")}</label>
                      <div style={{ marginBottom: "1rem" }}>
                        <UsersSelect
                          user={creator}
                          onChange={this.handleCreatorChange}
                        />
                      </div>
                    </li>
                    <li className="grid-y">
                      <label className="cell small-4">{_("Scope")}</label>
                      <div
                        style={{ marginBottom: "1rem" }}
                        className="custom-select"
                      >
                        <select
                          id="csScope"
                          name="csScope"
                          defaultValue={media ? media.csScope : ""}
                          onChange={this.handleCsScopeChange}
                        >
                          {scopes.slice(scopes.indexOf(cs_scope)).map(el => (
                            <option
                              value={el}
                              selected={
                                mediaPreferences &&
                                mediaPreferences.cs_default_scope &&
                                el === mediaPreferences.cs_default_scope
                              }
                            >
                              {el}
                            </option>
                          ))}
                        </select>
                      </div>
                    </li>
                    <li className="grid-y">
                      <label className="cell small-4">
                        {_("Tagged Users")}
                      </label>
                      <div style={{ marginBottom: "1rem" }}>
                        <UsersMultiSelect
                          users={taggedUsers}
                          onChange={this.handleTaggedUsersChange}
                        />
                      </div>
                    </li>
                    {/* <li className="grid-y">
                      <label className="cell small-4">{_("Copyright")}</label>
                      {this.renderCopyright()}
                    </li> */}

                    <li className="grid-x">
                      <div className="grid-x">
                        <Switch
                          id="in-the-news"
                          isChecked={inTheNews}
                          onChange={this.handleChangeInTheNews}
                        />
                        <label style={{ marginLeft: "8px" }}>
                          {_("Top media")}
                        </label>
                      </div>
                      <div className="grid-x" style={{ marginLeft: "auto" }}>
                        <Switch
                          name="private"
                          isChecked={isPrivate}
                          onChange={this.handleIsPrivateChange}
                        />
                        <label style={{ marginLeft: "8px" }}>
                          {_("Private")}
                        </label>
                      </div>
                    </li>
                    <li className="grid-y" style={{ paddingBottom: "1rem" }} />
                  </ul>
                </div>
                <div className="rmodal__right-actions">
                  <Button variant="secondary" onClick={this.closeModal}>
                    {_("Cancel")}
                  </Button>

                  <div>
                    {savingState === "default" && (
                      <Button onClick={this.handleSave} block={true}>
                        {_("Save")}
                      </Button>
                    )}
                    {savingState === "saving" && (
                      <Button
                        variant="default"
                        block={true}
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        <Loader
                          color={"#000"}
                          style={{
                            width: "2rem",
                            height: "2rem"
                          }}
                        />
                      </Button>
                    )}
                    {savingState === "success" && (
                      <Button
                        variant="default"
                        block={true}
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        <Checkmark
                          style={{
                            width: "24px",
                            height: "24px"
                          }}
                        />
                      </Button>
                    )}
                    {savingState === "error" && (
                      <Button variant="danger" block={true}>
                        {_("Error")}
                      </Button>
                    )}
                  </div>
                  {/* <Button onClick={this.handleSave}>{_("Save")}</Button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  navCommunity: state.auth.navCommunity,
  lng: state.params.lng,
  isOpen: state.mediaEditor.isOpen,
  media: state.mediaEditor.media,
  keepValues: state.mediaEditor.keepValues,
  titleFR: state.mediaEditor.titleFR,
  titleEN: state.mediaEditor.titleEN,
  titleNL: state.mediaEditor.titleNL,
  descriptionFR: state.mediaEditor.descriptionFR,
  descriptionEN: state.mediaEditor.descriptionEN,
  descriptionNL: state.mediaEditor.descriptionNL,
  altFR: state.mediaEditor.altFR,
  altEN: state.mediaEditor.altEN,
  altNL: state.mediaEditor.altNL,
  copyrightFR: state.mediaEditor.copyrightFR,
  copyrightEN: state.mediaEditor.copyrightEN,
  copyrightNL: state.mediaEditor.copyrightNL,
  tags: state.mediaEditor.tags,
  creator: state.mediaEditor.creator,
  taggedUsers: state.mediaEditor.taggedUsers,
  isPrivate: state.mediaEditor.isPrivate,
  inTheNews: state.mediaEditor.inTheNews,
  mediaStatus: state.mediaEditor.mediaStatus,
  csScope: state.mediaEditor.csScope,
  languages: state.mediaEditor.languages,

  images: state.medias.images.items,
  videos: state.medias.videos.items,
  pdfs: state.medias.pdfs.items,
  ppts: state.medias.ppts.items
});

const mapDispatchToProps = dispatch => ({
  saveMedia: options => dispatch(saveMedia(options)),
  // setImageEditor: options => dispatch(setImageEditor(options)),
  resetMediaEditor: () => dispatch(resetMediaEditor()),
  setMediaEditor: options => dispatch(setMediaEditor(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaEditor);



// WEBPACK FOOTER //
// ./src/components/Reveal/MediaEditor/MediaEditor.js